export default "__VITE_ASSET__C66U$UZC__"